import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[routerLink]',
  standalone: false
})
export class NavigateDirective {
  @Input('routerLink') routerParams: any[];
  @HostBinding('class') elementClass = 'lineup-gtm-track';

  constructor(
    private el: ElementRef,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  @HostListener('click') onClick() {
    if (!this.routerParams) return;

    let nextUrlTree = this.router.createUrlTree(this.routerParams, { relativeTo: this.route });
    let nextUrl = nextUrlTree.toString();
    let buttonText = this.el.nativeElement.title
      ? this.el.nativeElement.title
      : this.el.nativeElement.innerText;

    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      lineupGtmAction: `Button Click: "${buttonText}"`,
      lineupGtmCategory: 'Navigation',
      lineupGtmLabel: `${this.router.url} -> ${nextUrl}`,
      event: 'lineupGtmTrackClick'
    });
  }
}
